import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  inject,
  OnInit,
  QueryList,
  Renderer2,
  signal,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import { Validators } from '@angular/forms';
import {
  ClashDto,
  ClashTwinDto,
  InscricaoCabecaChaveDto,
} from '@models/clash/clash-dto';
import { ClashForm } from '@models/clash/clash-form.dto';
import { ClashDto as EmbateDto } from '@models/embate/clash-dto';
import { MetadataPutEnum } from '@models/enums/metadata-put-enum';
import { IPage } from '@models/pagination/page';
import { IPageable } from '@models/pagination/pageable';
import { PagedDropdownComponent } from '@shared/components/paged-dropdown/paged-dropdown.component';
import { ClashService } from '@shared/services/competition/clash.service';
import { BaseComponent } from '../../../../utilities/base-component/base-component';

@Component({
  selector: 'sigecom-clash-definition',
  templateUrl: 'clash-definition.component.html',
  styles: [
    `
      *::-webkit-scrollbar {
        width: 0px;
        height: 0px;
      }
      svg {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        overflow: visible;
        pointer-events: none;
      }
      path {
        stroke: #787878;
        stroke-width: 2;
        fill: none;
      }
    `,
  ],
})
export class ClashDefinitionComponent extends BaseComponent implements OnInit {
  printData() {
    console.log(this.inputsForm.value);
  }
  @ViewChildren('elements') elementos!: QueryList<ElementRef>;
  @ViewChild('winner') winner!: ElementRef<HTMLDivElement>;
  @ViewChild('svgContainer', { static: true })
  svgContainer!: ElementRef<SVGElement>;

  @ViewChild('participantDropdown')
  participantDropdown!: PagedDropdownComponent<InscricaoCabecaChaveDto>;
  @ViewChild('select') select!: ElementRef<HTMLSelectElement>;
  cheNrId = 2;

  searchText = '';

  inputsForm = this.fb.group({
    incNrId: this.fb.control<number | undefined>(undefined, [
      Validators.required,
    ]),
    entNrId: this.fb.control<number | undefined>(undefined, [
      Validators.required,
    ]),
    gameSide: this.fb.control<string | undefined>(undefined),
  });

  clashForm = this.fb.group({
    entNrId: this.fb.control<number | undefined>(undefined),
    entTxMetadado: this.fb.control<MetadataPutEnum>(MetadataPutEnum.ALTERADO),
    cheNrId: this.fb.control<number>(this.cheNrId),
    incNrIdA: this.fb.control<number | undefined>(undefined),
    incNrIdB: this.fb.control<number | undefined>(undefined),
  });

  clash?: ClashDto;
  embateDto?: EmbateDto;
  divs?: ElementRef[];
  jogos: number[] = [];

  participantsPage = signal<IPage<InscricaoCabecaChaveDto>>({});
  participantsPageable = signal<IPageable>({ page: 0, size: 20 });

  locationOptions = [
    { value: 'A', label: 'Casa' },
    { value: 'B', label: 'Fora' },
  ];

  #clashService = inject(ClashService);
  #renderer = inject(Renderer2);
  #cdr = inject(ChangeDetectorRef);

  ngOnInit(): void {
    this.fetchData();
    this.fetchParticipants();
  }

  ngAfterViewInit() {
    const svg = this.svgContainer.nativeElement;
    const data: ElementRef[][] = [];
    this.elementos.changes.subscribe((e) => {
      this.divs = e.toArray();
      if (this.divs) {
        for (let i = 0; i < this.divs.length; i++) {
          let j = 0;
          this.divs.forEach((e) => {
            if (e.nativeElement.id == i) {
              if (!data[i]) {
                data[i] = [];
              }
              data[i][j] = e;
              j++;
            }
          });
        }
      }
      for (let i = 0; i < data.length / 2 - 1; i++) {
        for (let j = 0, k = 0; j < data[i].length; j++, k++) {
          if (data[i + 1] && data[i][j + 1]) {
            this.conectarDivs(svg, data[i][j], data[i + 1][k]);
            this.conectarDivs(svg, data[i][j + 1], data[i + 1][k]);
            j++;
          }
        }
      }
      for (let i = data.length - 1; i > data.length / 2 + 1; i--) {
        for (let j = 0, k = 0; j < data[i].length; j++, k++) {
          if (data[i - 1] && data[i][j + 1]) {
            this.conectarDivs(svg, data[i][j], data[i - 1][k]);
            this.conectarDivs(svg, data[i][j + 1], data[i - 1][k]);
            j++;
          }
        }
      }
      for (let i = (data.length + 1) / 2; i > data.length / 2; i--) {
        for (let j = 0, k = 0; j < data[i].length; j++, k++) {
          if (data[i - 1] && data[i][j + 1]) {
            this.conectarDivs(svg, data[i][j], data[i - 1][k + 1]);
            this.conectarDivs(svg, data[i][j + 1], data[i - 1][k + 1]);
            this.conectarDivs(svg, data[i - 1][k], this.winner, true);
            this.conectarDivs(svg, data[i - 1][k + 1], this.winner, true);
            j++;
          }
        }
      }
      //this.generateGamesArray();
      this.#cdr.detectChanges();
      //detectChanges evita com que o angular estranhe a
      //geração do novo valor de gamesArray
    });
  }

  submitData(): void {
    this.#clashService.editClash(this.clashForm.value as ClashForm).subscribe({
      next: () => {
        console.log('Clash salvo com sucesso!');
        this.fetchData();
        this.fetchParticipants();
        this.clearInputs();
      },
      error: (error) => {
        console.error('Error:', error);
      },
    });
  }
  clearInputs() {
    this.participantDropdown.clearSelection();
    this.select.nativeElement.selectedIndex = -1;

    this.clashForm.reset();
  }

  fetchData(): void {
    this.#clashService.getClash(this.cheNrId).subscribe({
      next: (data) => {
        this.embateDto = data;
      },
    });
  }
  fetchParticipants() {
    this.#clashService
      .getParticipants(
        this.cheNrId,
        this.searchText,
        this.participantsPageable()
      )
      .subscribe({
        next: (data) => {
          this.participantsPage?.set(data);
        },
        error: (error) => {
          console.error('Error:', error);
        },
      });
  }
  setSearch($event: any) {
    console.log($event);
    this.searchText = $event;
    this.fetchParticipants();
  }
  setIncNrId() {
    if (this.inputsForm.controls.gameSide.value == 'A') {
      this.clashForm.patchValue({
        incNrIdA: this.inputsForm.controls.incNrId.value,
      });
      this.clashForm.patchValue({ incNrIdB: null });
    }
    if (this.inputsForm.controls.gameSide.value == 'B') {
      this.clashForm.patchValue({
        incNrIdB: this.inputsForm.controls.incNrId.value,
      });
      this.clashForm.patchValue({ incNrIdA: null });
    }
  }
  changePage($event: number) {
    this.participantsPageable().page = $event;
    this.fetchParticipants();
  }
  // generateGamesArray(): void {
  //   const jogos: number[] = [];

  //   if (this.clash) {
  //     for (let jogo of this.clash.listEmbates[0]) {
  //       jogos.push(jogo.embNrId);
  //     }
  //     for (let jogo of this.clash.listEmbates.at(-1)!) {
  //       jogos.push(jogo.embNrId);
  //     }
  //     jogos.sort((a, b) => a - b);
  //   }
  //   this.jogos = jogos;
  //   //.map(j => ({value: j}))
  // }
  isBye(data: ClashTwinDto): boolean {
    if (data.embTxDesfecho == 'BYE') {
      return true;
    } else {
      return false;
    }
  }
  isWon(winner: string, embTxVencedor?: string): boolean {
    if (!embTxVencedor) {
      return false;
    }

    if (winner == embTxVencedor) {
      return true;
    } else if (winner == embTxVencedor) {
      return true;
    } else {
      return false;
    }
  }
  isHead(item: ClashTwinDto, participant: string): boolean {
    // if (item.embObjInscricaoA) {
    //   if (participant == 'A' && item.embObjInscricaoA.incNrCabecaChave < 0) {
    //     return true;
    //   }
    // }
    // if (item.embObjInscricaoB) {
    //   if (participant == 'B' && item.embObjInscricaoB.incNrCabecaChave != -1) {
    //     return true;
    //   }
    // }
    return false;
  }
  calculateLeft(i: number): number {
    return i * 170 + 40;
  }
  calculateTop(index: number, level: number, winner?: boolean): number {
    const baseHeight = 80;
    //level = this.transformar(level, this.clash!.listEmbates[0][0].embNrEtapa);
    const factor = Math.pow(2, level); // 2^level
    const offset = factor / 2 - 1; // Ajuste de deslocamento
    let result = (baseHeight / 2) * (index * 1.1 * factor + offset);

    if (winner == true) {
      result = result - 200;
    }
    return result;
  }

  transformar(embNrEtapa: number, nrEmbates: number): number {
    return Math.log2(nrEmbates) - Math.log2(embNrEtapa) + 1;
  }

  conectarDivs(
    svg: SVGElement,
    div1: ElementRef,
    div2: ElementRef,
    winner?: boolean
  ) {
    const pos1 = div1.nativeElement.getBoundingClientRect();
    const pos2 = div2.nativeElement.getBoundingClientRect();
    const container = svg.parentElement!.getBoundingClientRect();

    const x1 = pos1.left + pos1.width - container.left;
    const y1 = pos1.top + pos1.height / 2 - container.top;
    const x2 = pos2.left - container.left;
    const y2 = pos2.top + pos2.height / 2 - container.top;

    let middleX = (x1 + x2) / 2;

    const path = this.#renderer.createElement('path', 'svg');
    let d = `M ${x1} ${y1} H ${middleX} V ${y2} H ${x2}`;
    if (winner) {
      middleX = pos2.left + pos2.width / 2 - container.left;
      const finalPoint = pos2.top + pos1.height - container.top;
      d = `M ${x1} ${y1} H ${middleX} V ${finalPoint}`;
    }
    this.#renderer.setAttribute(path, 'd', d);
    this.#renderer.appendChild(svg, path);
  }
}
